// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "1f1a90593214c3ed03125ad1b6cf72829228dd8d/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};